import { render, staticRenderFns } from "./UpdateCandidateView.vue?vue&type=template&id=f4a91daa&"
import script from "./UpdateCandidateView.vue?vue&type=script&lang=js&"
export * from "./UpdateCandidateView.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCandidateView.vue?vue&type=style&index=0&id=f4a91daa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports